// extracted by mini-css-extract-plugin
module.exports = {"editor":"richTextEditor_editor__k5nXW","toolbar":"richTextEditor_toolbar__2Y85v"};